import { h } from 'preact';
import cx from 'classnames';
import LinkItem from './link-item';
import MenuItem from './menu-item';
import style from './style';
import { isCurrent, currentSkinTier } from './util';

/**
 * The Component is used to determine how a nav items is to be rendered
 * depending on it's contents. A nav item can contain a subnav, and if it does,
 * it's treated as a 'MenuItem'. Otherwise, it will be treated as a 'LinkItem'.
 */
export default function Item({ item, current, skin, ...props }) {
	let TypedItem = (item.subnav && item.subnav.length) ? MenuItem : LinkItem;
	return (
		<TypedItem
			{...props}
			class={cx(style.item, isCurrent(item, current) && style.current, currentSkinTier(skin).item)}
			item={item}
			current={current}
			skin={skin}
		/>
	);
}